import { useNavigate } from 'react-router-dom';

const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-gradient-to-br from-teal-600 to-teal-700">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          Interested in Becoming a Partner?
        </h2>
        <p className="text-lg md:text-xl text-teal-50 mb-8 leading-relaxed">
          We're always looking to expand our network with qualified professionals who share our commitment to cybersecurity excellence and regulatory compliance. If you provide services that complement our offerings, we'd love to hear from you.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate('/schedule-call')}
            className="px-8 py-4 bg-white text-teal-700 rounded-lg font-semibold text-base hover:bg-gray-50 transition-colors duration-200 shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-line mr-2"></i>
            Schedule a Partnership Call
          </button>
          <button
            onClick={() => {
              const contactSection = document.querySelector('footer');
              contactSection?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-8 py-4 bg-teal-800 text-white rounded-lg font-semibold text-base hover:bg-teal-900 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line mr-2"></i>
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
